import { Button, Checkbox, Modal } from "antd";
import React, { useState } from "react";

const ForSendOutConfirmationModal = ({
  isOpen,
  onClose,
  handleAddLabtest,
  dataToBeAdded,
}) => {
  const [hasAcceptedAgreement, setHasAcceptedAgreement] = useState(false);

  return (
    <Modal
      open={isOpen}
      className="rounded-[8px]"
      width="600px"
      closable={false}
      footer={null}
      centered
    >
      {/* Details */}
      <div className="space-y-2">
        {/* Title */}
        <p className="text-[16px] font-[700] text-[#1F1F1F]">
          Notice: Test Outsourced to Partner Laboratory
        </p>
        <div className="bg-[#F3F8FF] rounded-[10px] p-[10px] flex flex-col gap-[15px]">
          <span className="text-[#1F1F1F] text-[14px] font-[400] tracking-[-0.84px]">
            This test is performed by our partner laboratory under our extended
            testing network. For test details, turnaround time, and pricing,
            please call our Client Service Representative.
          </span>
          <span className="text-[#1F1F1F] text-[14px] font-[400] tracking-[-0.84px]">
            By checking the box below, you acknowledge and accept the test
            arrangement and pricing.
          </span>
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-between items-center mt-3">
        <Checkbox
          onChange={(e) => setHasAcceptedAgreement(e.target.checked)}
          checked={hasAcceptedAgreement}
        >
          <span className="text-[12px] font-[700] text-[#1F1F1F]">
            I acknowledge and accept the terms of this test.
          </span>
        </Checkbox>
        <div className="flex items-center justify-center gap-2">
          <Button
            onClick={onClose}
            className="text-[#1976d2] hover:text-[#1976d2]/60"
            type="text"
          >
            Cancel
          </Button>
          <Button
            className="submitBtn"
            type="primary"
            disabled={!hasAcceptedAgreement}
            onClick={() => {
              handleAddLabtest(dataToBeAdded);
              onClose();
              setHasAcceptedAgreement(false);
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ForSendOutConfirmationModal;
